/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["keskööl","keskpäeval","hommikul","pärastlõunal","õhtul","öösel"],u,u],[["kesköö","keskpäev","hommik","pärastlõuna","õhtu","öö"],u,u],["00:00","12:00",["05:00","12:00"],["12:00","18:00"],["18:00","23:00"],["23:00","05:00"]]];
